import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { createRemarksAction } from '../../../redux/actions/orderActions.js'
import { clearErrors } from '../../../redux/actions/userActions.js'
import { useNavigate } from "react-router-dom"
import Loader from '../../loader/loader.jsx'

const RemarksForm = ({ order }) => {





    const navigate = useNavigate()

    const dispatch = useDispatch()
    const { loading, error, message } = useSelector((state) => state.createReport)




    const [remarks, setRemarks] = useState('')





    const displayID = String((order?.id)).padStart(6, '0');



    const handleSubmit = (e) => {
        e.preventDefault();


        if(!remarks) return toast.error("Please enter remarks");


        const myform = new FormData()




        myform.append("order_id", order.id)
        myform.append("remarks", remarks)




        dispatch(createRemarksAction(myform))

    }

    const handleReset = () => {
        setRemarks('')
    }



    useEffect(() => {
        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            toast.success(message)
            dispatch({ type: "CREATE_REPORT_RESET" })
            navigate("/orders/all-orders")
        }



    }, [navigate, dispatch, error, message]);




    return (
        <Fragment>
            {loading && <Loader/>}
            <div className="bg-white p-[2vmax] shadow-sm rounded-xl border border-gray-100 w-full mt-[1vmax]">
                <form action="" className="flex flex-col gap-[2vmax]" onSubmit={handleSubmit}>
                    <div className="flex items-center justify-between border-b border-gray-100 pb-[1vmax]">
                        <div className="flex items-center gap-[0.5vmax]">
                            <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                            <h3 className="text-[1.3vmax] font-bold text-gray-800">Order Remarks</h3>
                        </div>
                        <div className="flex items-center gap-[1vmax]">
                            <span className="text-[0.9vmax] text-gray-500 font-medium">Status:</span>
                            <span className={`text-[0.9vmax] font-bold uppercase p-[0.3vmax_0.8vmax] rounded-lg shadow-sm ${order?.status === 'ORDERED' ? 'text-green-600 bg-green-50' : 'text-indigo-600 bg-indigo-50'}`}>
                                {order?.status}
                            </span>
                        </div>
                    </div>

                    <div className="flex flex-col gap-[0.5vmax]">
                        <div className="flex items-center gap-[0.5vmax]">
                            <span className="text-[0.9vmax] text-gray-500 font-medium">Order ID:</span>
                            <span className="text-[1vmax] font-bold text-gray-700">#{displayID}</span>
                        </div>
                    </div>

                    <div className='flex flex-col w-full'>
                        <label className='text-[0.95vmax] font-bold text-gray-700 mb-[0.8vmax]' >Remarks <span className='text-red-600' >*</span></label>
                        <textarea 
                            name="" 
                            id="" 
                            rows={`8`} 
                            placeholder='Describe your remarks here...'
                            className='w-full px-[1.5vmax] py-[1.2vmax] rounded-xl border border-gray-200 outline-none focus:border-indigo-400 focus:ring-4 focus:ring-indigo-50 bg-gray-50 text-[1vmax] font-medium text-gray-700 transition-all resize-none placeholder-gray-400' 
                            value={remarks} 
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                    </div>

                    <div className="flex justify-end gap-[1vmax] border-t border-gray-100 pt-[1.5vmax]">
                        <button 
                            className="px-[2vmax] py-[0.7vmax] rounded-xl border border-gray-300 text-gray-600 font-bold text-[0.95vmax] hover:bg-gray-50 hover:text-gray-800 transition-colors shadow-sm" 
                            onClick={handleReset} 
                            type='button' 
                        >
                            Reset
                        </button>
                        <button 
                            className="px-[2vmax] py-[0.7vmax] rounded-xl bg-indigo-600 text-white font-bold text-[0.95vmax] hover:bg-indigo-700 transition-colors shadow-sm" 
                            type='submit' 
                        >
                            Submit Remarks
                        </button>
                    </div>
                </form>
            </div>
        </Fragment>
    )
}

export default RemarksForm